import React from 'react';

const AITermsContent = () => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Termos de Uso de Inteligência Artificial – Justiçai</h2>
      
      <p className="text-sm text-muted-foreground">
        Última atualização: 02 de setembro de 2025
      </p>
      
      <p>
        Estes Termos de Uso de Inteligência Artificial ("Termos de IA") regulam especificamente a utilização dos recursos 
        de inteligência artificial disponíveis na plataforma Justiçai ("Plataforma"), tecnologia desenvolvida e operada 
        pela Octopus Group – CNPJ 34.997.786/0001-85.
      </p>
      
      <p>
        Os presentes Termos de IA são complementares aos Termos de Uso Gerais da Plataforma e devem ser lidos em conjunto 
        com a Política de Privacidade e a Declaração de Conformidade com a LGPD.
      </p>
      
      <section>
        <h3 className="text-md font-medium mb-2">1. Natureza e Limitações da Tecnologia</h3>
        <p>
          1.1. A Plataforma utiliza Laib (IA proprietária da Octopus Group) como inteligência artificial principal, além de 
          integrações com IAs auxiliares de terceiros (Google, OpenAI, Claude, Grok, Deepseek e Perplexity).
        </p>
        <p className="mt-2">
          1.2. O usuário reconhece e compreende que:
        </p>
        <p className="mt-1">• A inteligência artificial é uma tecnologia em constante evolução, sujeita a falhas, vieses e limitações;</p>
        <p className="mt-1">• As respostas geradas são baseadas em padrões estatísticos e de treinamento, não constituindo aconselhamento jurídico;</p>
        <p className="mt-1">• As informações fornecidas podem ser imprecisas, incompletas, desatualizadas ou inadequadas ao caso concreto;</p>
        <p className="mt-1">• A IA não possui capacidade de julgamento profissional nem substitui a atuação de advogados ou outros profissionais qualificados;</p>
        <p className="mt-1">• O uso da Plataforma não estabelece relação advogado-cliente entre a Octopus Group e o usuário.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">2. Responsabilidade do Usuário</h3>
        <p>
          2.1. O usuário é o único responsável por:
        </p>
        <p className="mt-2">• Validar a precisão e adequação das informações fornecidas;</p>
        <p className="mt-1">• Utilizar seu julgamento profissional independente;</p>
        <p className="mt-1">• Adaptar documentos e textos gerados para o contexto específico do caso;</p>
        <p className="mt-1">• Garantir que o uso dos conteúdos esteja em conformidade com a legislação e normas aplicáveis;</p>
        <p className="mt-1">• Buscar orientação profissional adequada sempre que necessário.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">3. Isenção de Responsabilidade</h3>
        <p>
          3.1. A Octopus Group não garante que as respostas da IA sejam precisas, completas, livres de erros ou adequadas 
          a finalidades específicas.
        </p>
        <p className="mt-2">
          3.2. Em nenhuma hipótese a Octopus Group será responsável por:
        </p>
        <p className="mt-2">• Erros, omissões ou imprecisões nos conteúdos gerados;</p>
        <p className="mt-1">• Decisões ou atos jurídicos baseados no uso da IA;</p>
        <p className="mt-1">• Prejuízos diretos, indiretos, incidentais, consequenciais, punitivos ou exemplares decorrentes do uso ou da incapacidade de uso da IA;</p>
        <p className="mt-1">• Perdas ou danos de qualquer natureza relacionados às interações com a IA.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">4. Uso Adequado da IA</h3>
        <p>
          4.1. O usuário compromete-se a utilizar os recursos de IA exclusivamente para fins legítimos, relacionados à 
          prática jurídica e ao uso regular da Plataforma.
        </p>
        <p className="mt-2">
          4.2. É expressamente proibido utilizar a IA para:
        </p>
        <p className="mt-2">• Criar ou disseminar informações falsas, enganosas ou fraudulentas;</p>
        <p className="mt-1">• Produzir documentos com intenção de induzir a erro tribunais, autoridades ou terceiros;</p>
        <p className="mt-1">• Violar direitos de propriedade intelectual ou direitos de personalidade de terceiros;</p>
        <p className="mt-1">• Praticar atividades ilícitas, antiéticas ou contrárias à ordem pública;</p>
        <p className="mt-1">• Tentar manipular, corromper ou contornar os filtros de segurança e ética da Plataforma.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">5. Dados e Privacidade</h3>
        <p>
          5.1. O uso da IA envolve o processamento das informações fornecidas pelo usuário.
        </p>
        <p className="mt-2">
          5.2. A Octopus Group implementa medidas de segurança técnicas e organizacionais para proteger a confidencialidade 
          dos dados, em conformidade com a Política de Privacidade e a LGPD.
        </p>
        <p className="mt-2">
          5.3. Dados fornecidos podem ser utilizados para melhoria contínua dos sistemas de IA, sempre de forma anonimizada 
          ou pseudonimizada, quando aplicável.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">6. Atualizações e Melhorias</h3>
        <p>
          6.1. A Octopus Group poderá atualizar periodicamente seus modelos de IA para:
        </p>
        <p className="mt-2">• Corrigir falhas;</p>
        <p className="mt-1">• Incorporar novas bases jurídicas;</p>
        <p className="mt-1">• Aprimorar a qualidade das respostas.</p>
        <p className="mt-2">
          6.2. O usuário reconhece que a natureza e a qualidade das respostas podem variar ao longo do tempo em razão 
          dessas atualizações.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">7. Feedback e Relato de Erros</h3>
        <p>
          7.1. O usuário é encorajado a relatar eventuais erros, respostas inadequadas ou comportamentos imprecisos da IA.
        </p>
        <p className="mt-2">
          7.2. O feedback do usuário poderá ser utilizado para aprimorar os serviços de IA, respeitando sempre a privacidade 
          e a confidencialidade das informações.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">8. Disposições Finais</h3>
        <p>
          8.1. Estes Termos de IA podem ser atualizados a qualquer momento, para refletir mudanças tecnológicas, práticas 
          da Plataforma ou requisitos legais.
        </p>
        <p className="mt-2">
          8.2. O uso continuado da IA após a publicação de alterações constitui aceitação tácita dos novos termos.
        </p>
        <p className="mt-2">
          8.3. Caso qualquer cláusula destes Termos seja considerada inválida ou inexequível, as demais permanecerão em 
          pleno vigor e efeito.
        </p>
      </section>
    </div>
  );
};

export default AITermsContent;